var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoJul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2379.6 2379.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #b4ff38;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2686.4,213.5H1972.5c0,919.9-745.7,1665.7-1665.7,1665.7v713.9c1314.2,0,2379.6-1065.4,2379.6-2379.6",
    transform: "translate(-306.8 -213.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.1,974.1c122.7,122.7,122.7,321.6,0,444.2s-321.6,122.7-444.2,0-122.7-321.6,0-444.2,321.5-122.7,444.2,0",
    transform: "translate(-306.8 -213.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1511.7,305.5c122.7,122.7,122.7,321.6,0,444.2s-321.6,122.7-444.2,0-122.7-321.6,0-444.2,321.5-122.6,444.2,0",
    transform: "translate(-306.8 -213.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJul);
export default __webpack_public_path__ + "static/media/logoJul.901126345384d5b01a85afdb85b25c81.svg";
export { ForwardRef as ReactComponent };